
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
export default (props) => (<Dialog
    open={true}
    onClose={props.handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
>
    <DialogContent>
        <DialogContentText id="alert-dialog-description">
            {props.AlertText}
        </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={props.handleNo} color="primary">
            No
            </Button>
        <Button onClick={props.handleYes} color="primary" autoFocus>
            Yes
            </Button>
    </DialogActions>
</Dialog>)


// WEBPACK FOOTER //
// ./src/components/Dialogbox.js